<template>
<div class="top">
	<transition name="adslideup">
		<div class="top-ad trans-animate" v-if="topad && topad.ad_fixed && adShow">
			<i class="icon top-ad-close" @click="closeAd()">&#xe678;</i>			
			<a :href="topad.ad_fixed.link" class="top-ad-imgbox" style="width:1200px; margin: 0 auto;" :target="topad.ad_fixed.target">
				<img :src = "topad.ad_fixed.banner" 
					:alt = "topad.ad_fixed.desc"
				>
			</a>
		</div>
	</transition>
	<div class="top-head wrap clearfix" v-if="top">
		<a href="/" class="logo" style="position: relative;">
			<img class="fl" height="46" :src="$imgList.logo" alt="NextPCB">				
		</a>
		<div class="top-head-area">	
			<!-- 优惠券 -->
			<a id="iconCoupon" href="/member/finance/coupon" class="icon-btn">
				<div class="icon-coupon-new" style="width:32px; height:32px;"></div>
				<span v-if="top.couponCount && top.couponCount > 0" class="cart-num coupon-num" v-text="top.couponCount || 0"></span>
			</a>
			<!-- 购物车 -->
			<a href="/order/cart/type/1" class="icon-btn">
				<div class="icon-img icon-cart-new"></div>
				<span v-if="loginInfo.cartCount && loginInfo.cartCount > 0" class="cart-num" v-text="loginInfo.cartCount || 0"></span>
			</a>
			
			<!-- 消息 -->
			<a v-if="top.message" :href="top.message.href" class="icon-btn">
				<div class="icon-img icon-msg-new"></div>
			</a>

			<!-- 帮助中心 -->
			<a href="https://nextpcb.zohodesk.com.cn/portal/en/kb" target="_blank" class="icon-btn">
				<div class="icon-img icon-help-new"></div>
			</a>

			<!-- 日语站上线后同步修改 -->
			<span class="vlm top-hover-box top-head-area_item icon-btn">
				<i v-if="top && top.languageActive && top.languageActive.skin" :class="[top.languageActive.skin,top.languageActive.skin=='us'?'icon-country':'jp-icon']" class="iti-flag vlm "></i> 
				<div class="top-hover-sub">
					<template v-for="(v,i) in languageList">
						<a href="javascript:void(0);" @click="changeLanguage(v)" :key="i" class="hover-sub-item trans-animate"> 
							<i class="iti-flag vlm " :class="v.skin"></i> 
							{{v.text}}
						</a>
					</template>
				</div>
			</span>
			
			<span  class="vlm top-hover-box  top-head-area_item" style="margin:0;padding:0;">					
				<a class="icon-btn ">
					<div class="icon-img icon-user-new" :class="{'icon-user-new-login':isLogin}"></div>
				</a>
				
				<div class="top-hover-sub top-head-my" >
					<div class="top-head-my-info f-ct" v-if="!isLogin">
						<span class="vlm  pd-tb-sm">
							<a class="np-btn np-btn-main np-btn-ty pd-lg-lg mg-r-md" :href="loginUrl">{{languagePackage.LANG.login}}</a>
							<a class="np-btn np-btn-hollow-main np-btn-ty  pd-lg-xxl" :href="registerUrl">{{languagePackage.LANG.sign_up}}</a>
						</span>
					</div>
					<!-- 登錄成功 -->
					<dl  class="top-head-my-in bg-xs pd-md" v-else>
						<dt>
							<img width="44" height="44" class="u-avast-base" :src="loginInfo.avatar">
						</dt>
						<dd>
							<p class="  f-base">ID:	{{loginInfo.memberSn||loginInfo.member_sn}}	</p>
							<p class="fc6 s_name yui-top-login-name f-base"><em class="fc-main">Hi,</em> {{loginInfo.userName||loginInfo.name}}</p>
						</dd>
					</dl>
					
					<div class="top-head-my-list" v-if="accountList">
						<template v-for="(v,i) in accountList">
						<a class="top-head-my-item" :key="i" :href="v.href">
							<i class="icon trans-animate" v-html="v.icon"></i>
							<span class="trans-animate" v-text="v.name"></span>
						</a>	
						</template>
					</div>
					<!-- 退出登錄 -->
					<div  class="top-head-my-logout bg-sm pd-tb-sm" v-if="isLogin">
						<a class="np-btn np-btn-hollow-main np-btn-ty pd-lg-hg" @click="loginout">{{languagePackage.LANG.sign_out}}</a>
					</div>
				</div>
			</span>
		</div>			
	</div>
	<right-nav></right-nav>
</div>
</template>

<script>
import rightnav from '@/components/public/rightnav'
export default {
	data(){
		return {
			adShow:true,
			languageList: [
				{
					"text":"日本語",
					"code":"ja-jp",
					"skin":"jp"
				},
				{
					"text":"English",
					"code":"en-us",
					"skin":"us"
				}
			]
		}
	},
	watch: {
		$route(to){
			const stay = to.meta.stay
			if(stay == 'smt'){
				this.$store.dispatch("getAdinfo",{banner_code:'A03'});
			}else {
				this.$store.dispatch("getAdinfo",{banner_code:'A04'});
			}
		}
	},
	computed:{
		languagePackage(){
			return this.$store.getters.getLanguangeData || {LANG:{},MLANG:{}};
		},
		accountList() {
			return [
				{
					"name": this.languagePackage.LANG.my_nextpcb,
					"href": "/member",
					"icon": "&#xe641;"
				},
				{
					"name": this.languagePackage.LANG.my_cart,
					"href": "/order/cart/type/1",
					"icon": "&#xe62a;"
				},
				{
					"name": this.languagePackage.LANG.all_orders,
					"href": "/order/orderPacket",
					"icon": "&#xe600;"
				},
				{
					"name": this.languagePackage.LANG.my_coupon,
					"href": "/member/finance/coupon",
					"icon": "&#xe676;"
				},
				{
					"name": this.languagePackage.LANG.my_profile,
					"href": "/member/setting/profile",
					"icon": "&#xe624;"
				},
				{
					"name": this.languagePackage.LANG.my_address,
					"href": "/member/setting/address",
					"icon": "&#xe635;"
				}
			]
		},
		thisUrl(){
			return window.location.pathname + window.location.search ;
		},
		loginUrl() {			
			return this.$tools.getPassportHost() + '/?reurl=' + this.thisUrl
		},
		registerUrl() {
			return this.$tools.getPassportHost() + '/register?reurl=' + this.thisUrl
		},
		stay(){
			return this.$store.state.quote.stay;
		},
		admglt(){
			if(this.topad && this.topad.ad_fixed){
				if(this.topad.ad_fixed.width && this.topad.ad_fixed.width > 1200){
					return "margin-left:-"+(this.topad.ad_fixed.width-1200)/2+"px";
				}
			}
			return "";
		},
		topad(){
			let rst;
			if(this.stay == 'smt'){
				rst = this.$store.getters.getAds("A03");
			}else {
				rst = this.$store.getters.getAds("A04");
			}
			return rst;
		},
		isLogin(){
			return this.$store.getters.isLogin;
		},
		loginInfo(){
			return this.$store.getters.getLoginInfo;
		},
		firstName(){
			const name=this.loginInfo.userName||this.loginInfo.name
			if(name){
				return name.substr(0,1)
			}
			else{
				return 'R'
			}
		},
		top(){
			console.log('to99999999999p',this.$store.getters.getTopData)
			return this.$store.getters.getTopData;
		},
		redirect(){
			//需要注意上傳的路徑問題				
			let fullPath = this.$route.fullPath;
			let lastStr ;
			if(fullPath.length){
				lastStr = fullPath.charAt(fullPath.length - 1);
				if(lastStr === "/") fullPath = fullPath.substr(0,fullPath.length - 1);
			}			
			return window.location.protocol + "//" + window.location.host + fullPath +"/#"+ fullPath;
		}
	},
	components:{
		"right-nav":rightnav
	},
	methods:{
		loginout(){
			this.$http.jsonp(this.$api.logout).then((rsp)=>{
				if(rsp.retCode==200){
					// 登出成功后清除用户信息		
					this.$store.commit("clearUserInfo");	
					this.$http.get('/ssoapi/logout').then(() => {
						window.location.reload()	
					});	
					// this.$tools.setssoLogin(rsp.result.sso,token,"/pcb-quote",this.$http);										
				}else{
					window.location.href="/logout"
				}
			})			
		},
		closeAd: function(){
			this.adShow = false;
		},
		changeLanguage(v){
			//切換語種 v	
			return this.$http.post(this.$api.changeLanguage,{ajax:1,lang:v.code,redirect:this.redirect}).then((res)=>{
				if(res.code == 200){
					//切換后跳轉到對應域名									
					window.location.href = res.data.redirect;
				}
			})
		}
	}
}
</script>
<style  lang="scss">
$ad-close-color:$color-white;
$ad-close-size: $font-size-sm;
$ad-close-width: 22px;
$ad-close-bg: $color-bg-opcity6;
$head-padding: 16px;
$logoheight: 52px;
$top-hover-bg: #f7f7f7;
$top-head-cartnumwidth: 20px;
.top {
	position: relative;
	z-index: 25;
}
.top-ad {
	position: relative;
	max-height: 80px;
	min-height: 60px;
	overflow: hidden;
	.top-ad-close {
		position: absolute;
		right: 0;
		color: $ad-close-color;
		font-size: $ad-close-size;
		width: $ad-close-width;
		height: $ad-close-width;
		text-align: center;
		line-height: $ad-close-width;
		background-color: $ad-close-bg;
		cursor: pointer;
		z-index: 2;
	}
	//top-ad-imgbox
	&-imgbox {
		display: block;
		text-align: center;
		img {
			width: 1920px;
			height: auto;
			margin-left: -360px;
			// max-height: 100%;
		}
	}
}
.top-head {
	// padding: $head-padding 0;
	padding-top: $head-padding !important;
	padding-bottom: $head-padding !important;
	//logo
	.logo {
		float: left;
	}
	//top-head-area
	&-area {
		float: right;
		height: $logoheight;
		line-height: $logoheight;
		.top-hover-box {
			margin: 0 $space-padding-md;
		}
	}
}
//hover
.top-hover-box {
	line-height: $height-bs;
	padding: 0 7px;
	border-radius: $border-radius-xs;
	cursor: pointer;
	position: relative;
	&:hover {
		background-color: $color-bg-sm;
		.top-hover-sub {
			display: block;
		}
		.top-hover-arr {
			transform: rotate(180deg);
		}
	}
}
.top-hover-sub {
	display: none;
	position: absolute;
	box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
	background-color: $color-bg-sm;
	left: 0;
	padding: $space-padding-sm;
	min-width: 162px;
	
}
.hover-sub-item {
	display: block;
	border-radius: $border-radius-xs;
	padding: 0 $space-padding-xs;
	&:hover {
		background-color: $color-bg-deep;
	}
}

.top-head-cartnum {
	color: $color-white;
	height: $top-head-cartnumwidth;
	line-height: $top-head-cartnumwidth;
	border-radius: $top-head-cartnumwidth;
	padding: 0 $space-padding-xs;
	background-color: $color-org;
}
//top-head-my
.top-head-my {
	width: 300px;
	right: 0;
	left: auto;
	background-color: $color-white;
	padding: 0;
}
.top-head-my-info {
	text-align: center;
	background-color: $color-bg-sm;
}
.top-head-my-list {
	text-align: center;
	padding:  $space-padding-bs 0;
}
.top-head-my-item {	
	display: inline-block;
	width: 49%;
	vertical-align: middle;
	padding:  $space-padding-xs 0;
	.icon {
		display: block; border-radius: $border-radius-hg;
		margin: 0 auto; 
		font-size: $font-size-xl;
		width: 30px;
		height: 30px;
	}
	&:hover {
		color: $color-main;
		.icon {
			color: $color-white;
			background-color: $color-bg-main;
		}
	}
}
.top-head-my-in {
	dt {
		float: left;
	}
	dd {
		padding-left: $space-padding-md;
		display: block;
		overflow: hidden;
		line-height: 1.3;
	}
}
.top-head-my-logout { text-align: center;}
//動畫
.adslideup-leave-active {	
	margin-top: -80px;
}
.bell-ani {
  display: inline-block;
  -webkit-animation: bells 0.8s linear infinite;
  -moz-animation: bells 0.8s linear infinite;
  -o-animation: bells 0.8s linear infinite;
  animation: bells 0.8s linear infinite; }

@-webkit-keyframes bells {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg); }
  6% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg); }
  12% {
    -webkit-transform: rotate(10deg);
    transform: rotate(10deg); }
  18% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg); }
  24% {
    -webkit-transform: rotate(10deg);
    transform: rotate(10deg); }
  30% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg); }
  40% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg); }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg); } }

@keyframes bells {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg); }
  6% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg); }
  12% {
    -webkit-transform: rotate(10deg);
    transform: rotate(10deg); }
  18% {
    -webkit-transform: rotate(-10deg);
    transform: rotate(-10deg); }
  24% {
    -webkit-transform: rotate(10deg);
    transform: rotate(10deg); }
  30% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg); }
  40% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg); }
  100% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg); } 
}

.logo-title-quote{
	position: absolute;
	right: -8px;
	top: 12px;
	font-size: 12px;
	font-weight: 700;
	transform: scale(0.93);
	background: #f2f2f2;
	pointer-events: none;
}

@media screen and (max-width: 1399px) {
  .top-ad-imgbox img {
    transform: scale(0.865);
    transform-origin: top;
  }
}
</style>
